import { render, staticRenderFns } from "./ChannelReport.vue?vue&type=template&id=3cf0f38f&scoped=true"
import script from "./ChannelReport.vue?vue&type=script&lang=js"
export * from "./ChannelReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf0f38f",
  null
  
)

export default component.exports